import React from "react";

const Mobile = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 56 56"
      className={className}
    >
      <title>How It Works</title>
      <path d="M45.2,0H10.8A4.16,4.16,0,0,0,6.6,4.12V51.88A4.17,4.17,0,0,0,10.8,56H45.2a4.16,4.16,0,0,0,4.2-4.12V4.12A4.16,4.16,0,0,0,45.2,0ZM8.85,52.67V3.33A1.37,1.37,0,0,1,10.22,2H45.78a1.37,1.37,0,0,1,1.37,1.37V52.67A1.37,1.37,0,0,1,45.78,54H10.22A1.37,1.37,0,0,1,8.85,52.67Z" />
      <path d="M45.91,6.21H10.09V46.12H45.91ZM43.66,8.32V44H12.34V8.32Z" />
      <path d="M28,46.92A3.09,3.09,0,1,0,31.18,50,3.14,3.14,0,0,0,28,46.92ZM28,51a1,1,0,1,1,1.09-1A1.07,1.07,0,0,1,28,51Z" />
    </svg>
  );
};

export default Mobile;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/Mobile.icon.js